import React from "react";
import search from '../../images/Search.svg';
import i18n from "../../i18n";

export function NoImage({ styles }) {
    return (
        <div className={styles.semJob}>
            <div className={styles.searchContainer}>
                <img src={search} width={60} />
            </div>
            <p>{i18n.t("PORTAL.COMPONENT.NO_IMAGES_FOUND")}</p>
        </div>
    );
}
